import { Controller } from "@hotwired/stimulus"

// Toggles the visibility of a detail row beneath a summary row in a
// table. Use on the summary row with a `detail` target pointing at
// the hidden `<tr>` row (data-row-expander-target="detail").
export default class extends Controller {
  static targets = ["detail", "chevron"]

  connect() {
    console.log("[row-expander] connect")
  }

  toggle(event) {
    if (event && event.target && event.target.closest("a, button")) return
    if (!this.hasDetailTarget) return
    this.detailTarget.classList.toggle("hidden")
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-90")
    }
  }
}
